module.exports = __webpack_public_path__ + "media/images/Header-02-07335cff.png";